import {Component, Input, EventEmitter, Output} from '@angular/core';
import {TriggerExpression} from '@models/adminstration/machine/trigger/trigger-expression';
import {ExpressionSignal} from '@models/adminstration/machine/trigger/expression-signal';
import {TRIGGER_TYPE} from '@constants/administration/machine/trigger-type';

@Component({
    selector: 'scitis-admin-trigger-expression-table',
    templateUrl: './trigger-expression-table.component.html',
    styleUrls: ['./trigger-expression-table.component.scss'],
    standalone: false
})

export class TriggerExpressionTableComponent {

  @Input()
  isAdminOrHigher = false;

  @Input()
  triggerSignalExpressions: TriggerExpression[] = [];

  @Input()
  triggerTimeExpressions: TriggerExpression[] = [];

  @Input()
  signals: ExpressionSignal[] = [];

  @Input()
  triggerExecutionInDataflow: boolean = false;
  @Input()
  gatewaySelected: boolean = false;

  @Input()
  selectedTriggerType: string = '';

  @Output()
  updatedTriggerExpressions: EventEmitter<TriggerExpression[]> = new EventEmitter<TriggerExpression[]>();

  @Output()
  updatedTriggerTimeExpressions: EventEmitter<TriggerExpression[]> = new EventEmitter<TriggerExpression[]>();

  @Output()
  deletedTriggerTimeExpression: EventEmitter<TriggerExpression> = new EventEmitter<TriggerExpression>();

  @Output()
  deletedTriggerSignalExpression: EventEmitter<TriggerExpression> = new EventEmitter<TriggerExpression>();

  activeTab = 1;

  constructor() {
  }

  onUpdatedTriggerTimeExpressions(triggerExpressions: TriggerExpression[]) {
    this.updatedTriggerTimeExpressions.emit(triggerExpressions);
  }

  onUpdatedTriggerExpressions(triggerExpressions: TriggerExpression[]) {
    this.updatedTriggerExpressions.emit(triggerExpressions);
  }

  onDeleteTriggerTimeExpression(triggerExpressionToDelete: TriggerExpression){
    this.deletedTriggerTimeExpression.emit(triggerExpressionToDelete);
  }

  onDeleteTriggerSignalExpression(triggerExpressionToDelete: TriggerExpression){
    this.deletedTriggerSignalExpression.emit(triggerExpressionToDelete);
  }

  onShowTimeExpressions(){
    return this.triggerExecutionInDataflow && this.selectedTriggerType === TRIGGER_TYPE.VALUE_BASED;
  }

}
